// extracted by mini-css-extract-plugin
export default {"root":"RadiosWrap_root__5ImPG","row":"RadiosWrap_row__cFOFn","column":"RadiosWrap_column__Q7J3D"};